import { IconProps, iconA11yProps } from '../types';

export const ChatSettings = ({ classNames, label }: IconProps) => (
    <svg className={`${classNames}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...iconA11yProps(label)}>
        <path d="M12 19H5C3.89543 19 3 18.1046 3 17V8C3 6.89543 3.89543 6 5 6H23L20 9V12" />
        <path d="M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
        <path d="M19.001 15.5V17" />
        <path d="M19.001 21V22.5" />
        <path d="M22.0319 17.25L20.7329 18" />
        <path d="M17.2702 20L15.9702 20.75" />
        <path d="M15.9702 17.25L17.2702 18" />
        <path d="M20.7329 20L22.0329 20.75" />
    </svg>
);
